'use client';
import { useMutation as useMutation$1 } from '@tanstack/react-query';
import { useContext } from 'react';
import { composeMutationKey } from '../lib/composeMutationKey.js';
import { useQueryClient } from '../lib/useQueryClient.js';
import { QraftContext } from '../QraftContext.js';

const useMutation = (qraftOptions, schema, args)=>{
    const [parameters, options, queryClientByArg] = args;
    if (parameters && typeof parameters === 'object' && options && 'mutationKey' in options) throw new Error(`'useMutation': parameters and 'options.mutationKey' cannot be used together`);
    const contextValue = useContext(qraftOptions?.context ?? QraftContext);
    const mutationKey = options && 'mutationKey' in options ? options.mutationKey : composeMutationKey(schema, parameters);
    return useMutation$1({
        ...options,
        mutationKey,
        mutationFn: options?.mutationFn ?? (parameters ? function(bodyPayload) {
            if (!contextValue?.requestFn) throw new Error(`QraftContext.requestFn not found`);
            return contextValue.requestFn(schema, {
                parameters,
                baseUrl: contextValue.baseUrl,
                body: bodyPayload
            });
        } : function(parametersAndBodyPayload) {
            if (!contextValue?.requestFn) throw new Error(`QraftContext.requestFn not found`);
            const { body, ...parameters } = parametersAndBodyPayload;
            return contextValue.requestFn(schema, {
                parameters,
                baseUrl: contextValue.baseUrl,
                body
            });
        })
    }, useQueryClient(qraftOptions, queryClientByArg));
};

export { useMutation };
//# sourceMappingURL=useMutation.js.map
